<template lang="html">
  <div class="profile-notifications-wrapper">
    <Messages />
  </div>
</template>

<script>
import Messages from "@/components/profile/messages.vue";
export default {
  name: "profileNotifications",
  components: {
    Messages
  }
};
</script>

<style lang="scss" scoped>
.profile-notifications-wrapper {
  padding-left: 40px;
}
@media screen and (max-width: 1000px) {
  .profile-notifications-wrapper {
    padding-left: 5px;
  }
}
</style>
